import React, { createContext, useContext, useState } from 'react';

const BottomBarContext = createContext();

export function useBottomBar() {
  const context = useContext(BottomBarContext);
  if (!context) {
    throw new Error('useBottomBar must be used within a BottomBarProvider');
  }
  return context;
}

export function BottomBarProvider({ children }) {
  const [showBottomBar, setShowBottomBar] = useState(false);
  const [bottomBarError, setBottomBarError] = useState(null);

  const resetStates = () => {
    if (typeof window !== 'undefined' && window.bottomBarResetStates) {
      window.bottomBarResetStates();
    }
  };

  const value = {
    showBottomBar,
    setShowBottomBar,
    bottomBarError,
    setBottomBarError,
    resetStates
  };

  return (
    <BottomBarContext.Provider value={value}>
      {children}
    </BottomBarContext.Provider>
  );
} 
